export default __webpack_public_path__ + "static/media/stablecoins.76b5c555.png";